import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SSO_LOGIN_USER, SSO_LOGIN_SUCCESS } from "./actionTypes"
import { apiError, loginSuccess, logoutUserSuccess } from "./actions"

import {
    postLogin,
    postSsoLogin,
    getCSRF,
} from "../../../helpers/auth_helper"

import cogoToast from "cogo-toast"
import { getFilters } from "store/actions"

function* loginUser({ payload: { user, history } }) {

    console.log('INTERCEPTED', process.env.REACT_APP_DEFAULTAUTH);

    try {
        const token = yield call(getCSRF);
        console.log('SG tkn', token)
        const response = yield call(postLogin, {
            username: user.username,
            password: user.password,
        })
        console.log('SG Respo', response)
        if (response.status == 200) {
            localStorage.setItem("authUser", JSON.stringify(response.data))
            localStorage.setItem("userId", response.data.id)
            localStorage.setItem("userName", response.data.name)
            localStorage.setItem("roleId", response.data.role_id)
            let tempId = localStorage.getItem('oldUserId');
            let tempBlock = localStorage.getItem('oldUserBlock');
            let tempProperty = localStorage.getItem('oldUserProperty');
            if (tempId && tempBlock && tempProperty && (tempId == response.data.id)) {
                localStorage.setItem('userBlock', tempBlock);
                localStorage.setItem('userProperty', tempProperty);
                localStorage.removeItem('oldUserId');
                localStorage.removeItem('oldUserBlock');
                localStorage.removeItem('oldUserProperty');
            }
            yield put(loginSuccess(response.data));
            window.location.href = "/dashboard";
        } else if (response.status == 401) {
            cogoToast.error('Please check your credentials', {
                position: 'bottom-right',
                heading: 'Login failed'
            });
            //
        } else {
            cogoToast.error('Something went wrong', {
                position: 'bottom-right',
                heading: 'Login failed'
            });
        }

        // }
    } catch (error) {
        yield put(apiError(error))
    }
}

function* ssoLoginUser({ payload: { user, history } }) {
    try {
        const token = yield call(getCSRF);
        // console.log('SSO tkn', token)
        const response = yield call(postSsoLogin, {
                username: user.username,
                password: user.password,
                role_id: user.role_id,
                sites: user.sites,
                token: user.token,
            })
            // console.log('SSO Login Resp', response)
        if (response.status == 200) {
            localStorage.setItem("authUser", JSON.stringify(response.data))
            yield put(loginSuccess(response.data));
            history.push("/dashboard")
        } else if (response.status == 401) {
            cogoToast.error(response.message, {
                position: 'bottom-right',
                heading: 'Login failed'
            });
            //
        } else {
            cogoToast.error('Something went wrong', {
                position: 'bottom-right',
                heading: 'Login failed'
            });
        }

        // }
    } catch (error) {
        yield put(apiError(error))
    }
}

function* logoutUser({ payload: { history } }) {
    try {
        let oldId = localStorage.getItem('userId');
        let oldBlock = localStorage.getItem('userBlock');
        let oldProperty = localStorage.getItem('userProperty');
        localStorage.setItem("oldUserId", oldId);
        localStorage.setItem("oldUserBlock", oldBlock);
        localStorage.setItem("oldUserProperty", oldProperty);
        localStorage.removeItem("authUser");
        localStorage.removeItem("userProperty");
        localStorage.removeItem("userBlock");
        localStorage.removeItem("userName");
        localStorage.removeItem("userId");
        localStorage.removeItem("roleId");

        // if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        //   const response = yield call(fireBaseBackend.logout)
        //   yield put(logoutUserSuccess(response))
        // }
        history.push("/login")
    } catch (error) {
        yield put(apiError(error))
    }
}


function* authSaga() {
    yield takeEvery(LOGIN_USER, loginUser)
    yield takeEvery(SSO_LOGIN_USER, ssoLoginUser)
    yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga